document.addEventListener("DOMContentLoaded", function () {
    BOLD.common.eventEmitter.on("BOLD_OPTIONS_option_products_loaded", () => {
        document.querySelectorAll(".bold_options_loaded .bold_option_swatch label").forEach(swatch => {
            const span = swatch.querySelector(".bold_option_value_swatch > span");
            const styleAttr = span.getAttribute("style");

            const decoded = new DOMParser()
                .parseFromString(styleAttr, 'text/html')
                .documentElement.textContent;

            const imgUrl = decoded.match(/url\(["']?(.*?)["']?\)/)[1];

            const tooltip = swatch.querySelector(".bold_option_swatch_title");
            const newImgEl = document.createElement("img");
            newImgEl.src = imgUrl;

            tooltip.appendChild(newImgEl);
        });
    });

    BOLD.common.eventEmitter.on("BOLD_OPTIONS_option_changed", () => {
        setTimeout(updateMainPrice, 100);
    });

    const qtyInputEl = document.querySelector(".product-form__buttons .quantity__input");
    if (qtyInputEl) {
        qtyInputEl.addEventListener("change", () => setTimeout(updateMainPrice, 100));
        qtyInputEl.addEventListener("input", () => setTimeout(updateMainPrice, 100));
    }
});

function updateMainPrice() {
    const boldTotal = document.querySelector(".bold_options_loaded .bold_option_total");
    const mainPrice = document.querySelector("span.price-item.price-item--regular");

    if (!mainPrice) return;

    let currentText = mainPrice.textContent.trim();

    if (mainPrice.dataset.lastRenderedText && currentText !== mainPrice.dataset.lastRenderedText) {
        mainPrice.dataset.originalText = currentText;
    } else if (!mainPrice.dataset.originalText) {
        mainPrice.dataset.originalText = currentText;
    }

    const originalText = mainPrice.dataset.originalText;

    const priceMatch = originalText.match(/[\d,\.]+/);
    if (!priceMatch) return;

    let priceStr = priceMatch[0];

    let isCommaDecimal = priceStr.lastIndexOf(',') > priceStr.lastIndexOf('.');

    let cleanBaseStr = isCommaDecimal
        ? priceStr.replace(/\./g, '').replace(',', '.')
        : priceStr.replace(/,/g, '');

    let basePrice = parseFloat(cleanBaseStr) || 0;

    let optionsCharge = 0;
    if (boldTotal) {
        const inputElement = boldTotal.querySelector('input[name="properties[_scVariantPrices]"]');
        if (inputElement && inputElement.value) {
            const sum = inputElement.value
                .split(',')
                .reduce((acc, val) => acc + Number(val), 0);
            optionsCharge = sum / 100;
        }
    }

    let finalTotal = basePrice + optionsCharge;

    let finalTotalStr = finalTotal.toFixed(2);
    if (isCommaDecimal) {
        let parts = finalTotalStr.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        finalTotalStr = parts.join(',');
    } else {
        let parts = finalTotalStr.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        finalTotalStr = parts.join('.');
    }

    const newlyRenderedText = originalText.replace(priceStr, finalTotalStr);
    
    mainPrice.textContent = newlyRenderedText;
    
    mainPrice.dataset.lastRenderedText = newlyRenderedText;
}